import styled from 'styled-components';

export const CompanyListsWrapper = styled.div`
  margin-top: 10px;
`;
